import { Injectable } from "@angular/core";
import { EERROR_BEHAVIORS, EERROR_CATEGORY, EhrBaseError } from "../ehr.error";
import { Router } from "@angular/router";
import { ToastService } from "@ehrSharedResources/services/toast/toast.service";
import { GlobalMessageType } from "@ehrCore/interceptors/models/global-message.model";

@Injectable({
  providedIn: "root"
})
export class EhrErrorHandlerService {

  constructor(private router: Router, private toastService: ToastService) { }

  handleError(error: EhrBaseError) {
    switch (error.behavior) {
      case EERROR_BEHAVIORS.SHOW_ERROR_PAGE:
        this.handleShowErrorPage(error.name as EERROR_CATEGORY, error.message);
        break;

      case EERROR_BEHAVIORS.SHOW_TOAST:
        this.handleShowToast(error.name as EERROR_CATEGORY, error.message, error.title, error.type);
        break;

      default:
        console.error("Unhandled error behavior:", error);
    }
  }

  handleShowErrorPage(category: EERROR_CATEGORY, message: string) {
    console.error(`Error Category: ${category}, Message: ${message}`);
    this.router.navigate(["/error"], {
      queryParams: {
        error: `${message}`
      }
    });
  }


  handleShowToast(category: EERROR_CATEGORY, message: string, title?: string, type?: GlobalMessageType) {
    this.toastService.publishToast({
      content: message,
      type
    });
  }
}
